/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddSource_allSources$ref = any;
export type AddSourceContainer_allSources_QueryVariables = {|
  searchBy: string,
  byCategory?: ?string,
|};
export type AddSourceContainer_allSources_QueryResponse = {|
  +allSources: ?{|
    +$fragmentRefs: AddSource_allSources$ref
  |}
|};
export type AddSourceContainer_allSources_Query = {|
  variables: AddSourceContainer_allSources_QueryVariables,
  response: AddSourceContainer_allSources_QueryResponse,
|};
*/


/*
query AddSourceContainer_allSources_Query(
  $searchBy: String!
  $byCategory: String
) {
  allSources(searchBy: $searchBy, byCategory: $byCategory) {
    ...AddSource_allSources
  }
}

fragment AddSource_allSources on SourceNodeConnection {
  edges {
    node {
      id
      name
      edited_name
      description
      edited_description
      image_url
      source_icon
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "byCategory"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v2 = [
  {
    "kind": "Variable",
    "name": "byCategory",
    "variableName": "byCategory"
  },
  {
    "kind": "Variable",
    "name": "searchBy",
    "variableName": "searchBy"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSourceContainer_allSources_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SourceNodeConnection",
        "kind": "LinkedField",
        "name": "allSources",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddSource_allSources"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddSourceContainer_allSources_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SourceNodeConnection",
        "kind": "LinkedField",
        "name": "allSources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SourceNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edited_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edited_description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image_url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "source_icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24eb5a820590ea0e079e5497c3637576",
    "id": null,
    "metadata": {},
    "name": "AddSourceContainer_allSources_Query",
    "operationKind": "query",
    "text": "query AddSourceContainer_allSources_Query(\n  $searchBy: String!\n  $byCategory: String\n) {\n  allSources(searchBy: $searchBy, byCategory: $byCategory) {\n    ...AddSource_allSources\n  }\n}\n\nfragment AddSource_allSources on SourceNodeConnection {\n  edges {\n    node {\n      id\n      name\n      edited_name\n      description\n      edited_description\n      image_url\n      source_icon\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2de85ee32e851e50e469413d426d9057';

module.exports = node;
